import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './global/scss/global.scss'
import md5 from 'js-md5';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import {
    req
} from '../src/utils/http'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.use(ElementUI);

import Distpicker from 'v-distpicker'

Vue.component('v-distpicker', Distpicker)

Vue.prototype.$md5 = md5;
Vue.config.productionTip = false;
Vue.use(Argon);
Vue.prototype.http = req

new Vue({
    router,
    render: h => h(App)
}).$mount("#app");